import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Card,
	CardContent,
	Grid,
} from '@material-ui/core';
import {
	MyPATDialog,
	MyPATTextField
} from '../../common';
import courseServices from '../services/courseService';

const styles = (theme: Theme) => createStyles({
});

interface DisplayNameDialogProps extends WithStyles<typeof styles> {
	isOpen: boolean,
	handleClose: () => void,
	selectedContent: any,
	handleListContent: () => void,
}

interface DisplayNameDialogState {
	displayName: string,
}

class DisplayNameDialog extends Component<DisplayNameDialogProps, DisplayNameDialogState> {
	constructor(props: DisplayNameDialogProps) {
		super(props);
		this.state = {
			displayName: '',
		}

		this.handleDisplayNameSave = this.handleDisplayNameSave.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleDisplayNameSave = () => {
		courseServices.updateTestData({
			...this.props.selectedContent,
			displayName: this.state.displayName
		})
		.then((res:any) => {
			this.props.handleListContent()
			this.props.handleClose()
		})
	}

	handleInputChange = (evt: any) => {
		const { name, value } = evt.target;
		this.setState(() => ({ [name]: value }));
	}

	render() {
		return (
			<MyPATDialog
				dialogHeading="Set Display Name"
				dialogOpen={this.props.isOpen}
				otherDialogProps={{
					fullWidth: true,
					maxWidth: 'sm',
				}}
				onDialogClose={this.props.handleClose}
				onDialogSave={this.handleDisplayNameSave.bind(this)}
				onDialogCancel={this.props.handleClose}
			>
				<Card>
					<CardContent>
						<Grid container spacing={8}>
							<Grid item sm={6}>
								<MyPATTextField
									fullWidthControl
									type="text"
									name="displayName"
									inputId="displayName"
									value={this.state.displayName}
									label="Enter Display Name"
									placeholder="Enter name here"
									onChange={this.handleInputChange.bind(this)}
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</MyPATDialog>
		)
	}
}

// @ts-ignore
export default withStyles(styles)(DisplayNameDialog);